module.exports = __webpack_public_path__ + "static/media/dessert.573002c2.svg";